import { getFormattedPractiseAdminRolesList, getFormattedRolesList } from '../../services';

const fetchAdminRoleManagementList = async ({
  verificationStatus,
  roleAssigned,
  role
}: {
  verificationStatus?: string;
  roleAssigned: boolean;
  role: string;
}) => {
  try {
    return await getFormattedRolesList(verificationStatus, roleAssigned, role);
  } catch (error) {
    console.error('Error fetching formatted doctor list:', error);
    throw error;
  }
};
const fetchPractiseAdminRoleManagementList = async (roleAssigned: string, role: string) => {
  try {
    return await getFormattedPractiseAdminRolesList(roleAssigned, role);
  } catch (error) {
    console.error('Error fetching formatted doctor list:', error);
    throw error;
  }
};

export { fetchAdminRoleManagementList, fetchPractiseAdminRoleManagementList };
